// src/pages/OrderLinesReport.js
import { auth } from "../firebase";

import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  query,
  where,
  Timestamp,
  doc,
  getDoc
} from "firebase/firestore";
import { db } from "../firebase";
import Layout from "../components/Layout";
import { exportToExcel } from "../utils/exportToExcel";

function OrderLinesReport() {
  const today = new Date().toISOString().slice(0, 10);

  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [lines, setLines] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setTimeout(loadReport, 100);
  }, []);

  const toTs = (d, end = false) => {
    const dt = new Date(d);
    if (end) dt.setHours(23, 59, 59, 999);
    else dt.setHours(0, 0, 0, 0);
    return Timestamp.fromDate(dt);
  };

  const loadReport = async () => {
    try {
      setLoading(true);
      setLines([]);

      const user = auth.currentUser;
      const userSnap = await getDoc(doc(db, "users", user.uid));
      const userData = userSnap.data();

      let q;
      if (userData?.role === "distributor") {
          q = query(
            collection(db, "orderLines"),
            where("approvedAt", ">=", toTs(fromDate)),
            where("approvedAt", "<=", toTs(toDate, true)),
            where("distributorId", "==", userData.partyId || "---"),
            where("status", "==", "APPROVED")
          );
      } else if (userData?.role === "ds") {
          q = query(
            collection(db, "orderLines"),
            where("approvedAt", ">=", toTs(fromDate)),
            where("approvedAt", "<=", toTs(toDate, true)),
            where("dsId", "==", userData.dsId || "---"),
            where("status", "==", "APPROVED")
          );
      } else {
          q = query(
            collection(db, "orderLines"),
            where("approvedAt", ">=", toTs(fromDate)),
            where("approvedAt", "<=", toTs(toDate, true)),
            where("status", "==", "APPROVED")
          );
      }

      const snap = await getDocs(q);
      const rows = [];

      snap.forEach((d) => {
        const r = d.data();

        rows.push({
          OrderID: r.displayOrderId || "",
          ApprovedDate: r.approvedAt?.toDate().toLocaleDateString("en-IN"),

          ClientId: r.clientId || "",          // ✅ NEW
          VehicleNo: r.vehicleNo || "",        // ✅ NEW
          Address: r.address || "",
          gstno: r.gstno || "",

          DistributorId: r.partyId || "",
          DistributorName: r.partyName || "",
          DistributorPhone: r.partyPhone || "",
          DistributorType: r.partyType || "",
          DMSName: r.dmsName || "",
          EasyCigName: r.easyCigName || "",

          SKU: r.sku || "",
          ItemCode: r.itemCode || "",
          SKUName: r.skuName || "",
          Description: r.description || "",
          Brand: r.brand || "",
          MSKU: r.msku || "",
          Segment: r.segment || "",
          HSN: r.hsn || "",

          Qty: r.qty || 0,
          BasicRate: r.basicRate || 0,
          BasicAmount: r.basicAmount || 0,

          GST_pct: r.gstPercent || 0,
          GST_amt: r.gstAmount || 0,

          CESS_pct: r.cessPercent || 0,
          CESS_amt: r.cessAmount || 0,

          AddlCess_per_unit: r.addlCessPerUnit || 0,
          AddlCess_amt: r.addlCessAmount || 0,

          Rebate_per_unit: r.rebatePerUnit || 0,
          Rebate_amt: r.rebateAmount || 0,

          LineTotal: r.lineTotal || 0,
        });
      });

      rows.sort(
        (a, b) =>
          new Date(b.ApprovedDate) - new Date(a.ApprovedDate) ||
          b.OrderID.localeCompare(a.OrderID)
      );

      setLines(rows);
    } catch (e) {
      console.error(e);
      alert("Failed to load Order Lines Report");
    } finally {
      setLoading(false);
    }
  };

  const handleExport = () => {
    if (!lines.length) return alert("No data");
    exportToExcel({
      data: lines,
      fileName: `OrderLines_${fromDate}_${toDate}`,
      sheetName: "OrderLines",
    });
  };

  return (
    <Layout>
      <div className="layout-content">
        {/* HEADER SECTION */}
        <div style={{ marginBottom: 40, display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
            <div>
                <h1 style={{ fontSize: 32, marginBottom: 8, fontWeight: 900, letterSpacing: "-0.02em" }}>Line-Item Intelligence</h1>
                <p style={{ color: "var(--text-muted)", fontSize: 16 }}>Granular SKU-level manifest with full tax and rebate audit trails.</p>
            </div>
            <div style={{ display: "flex", gap: 12 }}>
                <button
                    onClick={handleExport}
                    className="btn-secondary"
                    style={{ background: "var(--surface)", display: "flex", alignItems: "center", gap: 8 }}
                >
                    <span style={{ color: "var(--success)" }}>Export Manifest</span>
                </button>
                <div style={{ display: "flex", alignItems: "center", gap: 12, background: "var(--surface)", padding: "0 16px", borderRadius: 12, border: "1px solid var(--border)", height: 48 }}>
                    <input 
                        type="date" 
                        value={fromDate} 
                        onChange={e => setFromDate(e.target.value)}
                        style={{ border: "none", background: "transparent", fontSize: 14, fontWeight: 700, color: "var(--text-main)", outline: "none" }}
                    />
                    <span style={{ color: "var(--text-muted)", fontWeight: 800 }}>→</span>
                    <input 
                        type="date" 
                        value={toDate} 
                        onChange={e => setToDate(e.target.value)}
                        style={{ border: "none", background: "transparent", fontSize: 14, fontWeight: 700, color: "var(--text-main)", outline: "none" }}
                    />
                    <button 
                        onClick={loadReport} 
                        style={{ marginLeft: 16, border: "none", background: "var(--primary)", color: "white", padding: "4px 12px", borderRadius: 8, fontSize: 12, fontWeight: 800, cursor: "pointer" }}
                    >
                        REFRESH
                    </button>
                </div>
            </div>
        </div>

        {/* DATA GRID */}
        <div className="premium-card" style={{ padding: 0, overflow: "hidden" }}>
            <div style={{ padding: "16px 24px", borderBottom: "1px solid var(--border)", background: "var(--surface-hover)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontSize: 12, fontWeight: 800, color: "var(--text-main)" }}>FULL MANIFEST AUDIT ({lines.length} ROWS)</span>
                <span style={{ fontSize: 11, fontWeight: 600, color: "var(--text-muted)" }}>HORIZONTAL SCROLL ENABLED FOR DEEP DATA</span>
            </div>

            <div style={{ overflowX: "auto", maxHeight: "70vh" }}>
                <table className="enterprise-table" style={{ minWidth: 2800 }}>
                    <thead style={{ position: "sticky", top: 0, zIndex: 10, background: "var(--surface)" }}>
                        <tr>
                            {lines.length > 0 && Object.keys(lines[0]).map((k) => (
                                <th key={k} style={{ whiteSpace: "nowrap" }}>{k.toUpperCase()}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan={lines.length > 0 ? Object.keys(lines[0]).length : 20} style={{ padding: 100, textAlign: "center" }}>
                                    <div style={{ fontSize: 16, fontWeight: 700, color: "var(--primary)" }}>DECRYPTING DATA MATRIX...</div>
                                </td>
                            </tr>
                        ) : lines.length === 0 ? (
                            <tr>
                                <td colSpan={20} style={{ padding: 80, textAlign: "center", color: "var(--text-muted)" }}>
                                    No records found for the specific audit dates.
                                </td>
                            </tr>
                        ) : (
                            lines.map((r, i) => (
                                <tr key={i}>
                                    {Object.values(r).map((v, j) => (
                                        <td key={j} style={{ whiteSpace: "nowrap", fontSize: 13, fontWeight: typeof v === 'number' ? 700 : 500 }}>
                                            {typeof v === "number" ? v.toLocaleString(undefined, { minimumFractionDigits: 2 }) : v}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
      </div>
    </Layout>
  );
}

export default OrderLinesReport;
